import { request } from '@/libs/api-request'

export function checkReferExist (params, force = true) {
  const url = '/referral/check_refer_exist'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function checkReferValidate (params, force = true) {
  const url = '/referral/check_refer_validate'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getReferralInfo (force = true) {
  const url = '/referral/get_referral_info'

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getReferralStateList (params, force = true) {
  const url = '/referral/get_referral_state_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getReferralHistory (params, force = true) {
  const url = '/referral/get_referral_history'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getRewardList (params, force = true) {
  const url = '/referral/get_reward_list'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function setReferralCode (params, force = true) {
  const url = '/referral/enter_refer_manage_plan'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function saveMemo (params, force = true) {
  const url = '/referral/save_memo'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
